import Plyr from "plyr/dist/plyr";

export default class VideoPLayer {

    constructor() {
        this.init();
    }

    init() {

        let players = document.querySelectorAll(".js-player");

        if (players.length < 1) {
            return;
        }

        for (let i = 0; i < players.length; i++) {
            const player = new Plyr(players[i]);
            player.poster = players[i].getAttribute("data-video-poster");
        }

    }

}
